import { ROUTE_DASHBOARD } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './dashboard.page';

export const routeDashboard: RouteObject = {
  path: ROUTE_DASHBOARD,
  Component: Page,
  loader: setTitleFromLoader('Dashboard'),
};
